module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sharon B. Siepel\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Sharon Siepel is a mother of four and an aunt to dozens. She has a degree in speech communications from Iowa State University, where she was awarded a writing scholarship. She is a freelance writer and the author of"), _c('I', [_vm._v(" Essential Survival Guide to Living on Your Own")]), _vm._v(". "), _c('BR', [_c('BR', [_vm._v(" ")])], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/2gKblu/tc-custom/9781416565673.jpg?1730494019983",
      "alt": "This image is the cover for the book Essential Survival Guide to Living on Your Own"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Essential Survival Guide to Living on Your Own\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_c('br'), _vm._v(" Are you ready to strike out on your own? "), _c('br')]), _c('br'), _vm._v(" In today's competitive world, you need all the help you can get. "), _c('i', [_vm._v("Essential Survival Guide")]), _vm._v(" provides you with how-to and hands-on instruction to make life less of a chore and more of an adventure. "), _c('br'), _c('br'), _vm._v(" Sections include: "), _c('br'), _c('b', [_vm._v("Getting through the Day")]), _vm._v(": Setting goals, organization, and understanding essential documents"), _c('b', [_vm._v("Money, Money, Money")]), _vm._v(": Learning about banking, credit, and debt; understanding taxes"), _c('b', [_vm._v("Getting Your Own Place")]), _vm._v(": Finding the right roommates, resolving conflicts, and purchasing a home"), _c('b', [_vm._v("Wheels")]), _vm._v(": Buying a car and purchasing car insurance; maintaining your new or used carAnd much more!"), _c('br'), _vm._v(" Independent living is only a read away. Full of practical advice in an easy-to-use format, this book covers everything from sorting laundry (yes, you have to sort) to choosing a church. The concise chapters and quick tips will make the learning fun and easy to apply.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Howard Books\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0